import { useEffect, useState } from "react";
import { getJourneyUi, getPricing, getQuestions } from "@/lib/journeyApi";

export const useJourneyContent = ({ questions = false, pricing = false } = {}) => {
  const [data, setData] = useState({ ui: null, questions: null, pricing: null, loading: true });

  useEffect(() => {
    let active = true;
    const requests = [getJourneyUi(), questions ? getQuestions() : Promise.resolve(null), pricing ? getPricing() : Promise.resolve(null)];
    Promise.all(requests)
      .then(([ui, questionData, pricingData]) => {
        if (active) setData({ ui, questions: questionData, pricing: pricingData, loading: false });
      })
      .catch(() => {
        if (active) setData((current) => ({ ...current, loading: false }));
      });
    return () => {
      active = false;
    };
  }, [pricing, questions]);

  return data;
};